// extracted by mini-css-extract-plugin
export var dropdownButton = "_24-0";
export var fullWidthDropdownButton = "_24-1";
export var icon = "_24-3";
export var iconPlaceholder = "_24-2";
export var menuItemRow = "_24-5";
export var shortcutContainer = "_24-4";